var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('v-card',{attrs:{"height":"100%"}},[_c('Dashboard')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }